module.exports = __webpack_public_path__ + "static/media/connect_with_oncologist.02ac8af4.svg";